module.exports = __webpack_public_path__ + "05_glasses_blue.6b4e75e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/05_glasses_blue.png
// module id = CmiO
// module chunks = 0